import React, { ReactElement } from "react";

import { IconChat } from "../icons/IconChat";
import {
  logoGradientTextCSS,
  headerCSS,
  draggableCSS,
  betaTagCSS,
  headerIconButtonCSS,
  headerIconsContainerCSS,
} from "./ChatDialogHeader.styles";
import classNames from "classnames";
import Button from "../../button";
import { ChatDialogHeaderProps } from "./ChatDialogHeader.types";

export const ChatDialogHeader = ({
  className,
  agentName = "Agent Name",
  isBeta = true,
  onFullScreenClick,
  onClose,
  modalRef,
  ...rest
}: ChatDialogHeaderProps): ReactElement => {
  const handleMouseDown = (event: React.MouseEvent<HTMLDivElement>): void => {
    const modal = modalRef?.current;
    if (!modal) {
      return;
    }

    const offsetX = event.clientX - modal.getBoundingClientRect().left;
    const offsetY = event.clientY - modal.getBoundingClientRect().top;

    const handleMouseMove = (moveEvent: MouseEvent): void => {
      modal.style.left = `${moveEvent.clientX - offsetX}px`;
      modal.style.top = `${moveEvent.clientY - offsetY}px`;
    };

    const handleMouseUp = (): void => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  return (
    <div
      className={classNames(headerCSS, { [draggableCSS]: modalRef }, className)}
      onMouseDown={handleMouseDown}
      {...rest}
    >
      <IconChat gradient style={{ width: 25, height: 25, marginRight: 8 }} />
      <span className={logoGradientTextCSS} style={{ marginTop: 1 }}>
        {agentName}
      </span>
      {isBeta && <span className={betaTagCSS}>BETA</span>}
      <div className={headerIconsContainerCSS}>
        <Button
          icon="out"
          label="Out"
          aria-label="Full Screen"
          className={headerIconButtonCSS}
          onClick={(e): void => {
            e.preventDefault();
            onFullScreenClick?.();
          }}
        />
        <Button
          icon="close"
          label="Close"
          aria-label="Close Chat"
          className={headerIconButtonCSS}
          style={{ fontSize: 16 }}
          onClick={(e): void => {
            e.preventDefault();
            onClose?.();
          }}
        />
      </div>
    </div>
  );
};
